export default "__VITE_ASSET__D0QOcQ2L__"